import { RRule, rrulestr } from 'rrule';
import { Weekday } from 'dayspan';
import moment from 'moment';

export function rruleParser(rrule) {
  const { origOptions } = rrulestr(rrule);
  const weekdayMap = {
    [RRule.MO]: Weekday.MONDAY,
    [RRule.TU]: Weekday.TUESDAY,
    [RRule.WE]: Weekday.WEDNESDAY,
    [RRule.TH]: Weekday.THURSDAY,
    [RRule.FR]: Weekday.FRIDAY,
    [RRule.SA]: Weekday.SATURDAY,
    [RRule.SU]: Weekday.SUNDAY,
  };

  const result = {};
  if (origOptions.byweekday) {
    result.dayOfWeek = origOptions.byweekday.map(weekday => weekdayMap[weekday]);
  }
  if (Number.isInteger(origOptions.byhour) && Number.isInteger(origOptions.byminute)) {
    result.times = [{ hour: origOptions.byhour, minute: origOptions.byminute }];
  }

  return result;
}

export function eventToSchedule({
  dtstart, dtend, duration, rrule,
}) {
  const schedule = {};

  // Non recurrent event
  if (!rrule) {
    schedule.year = [moment(dtstart).year()];
    schedule.month = [moment(dtstart).month()];
    schedule.dayOfMonth = [moment(dtstart).date()];

    schedule.times = [{ hour: moment(dtstart).hour(), minute: moment(dtstart).minute() }];

    if (dtend) {
      schedule.duration = moment.duration(moment(dtend).diff(moment(dtstart))).asMinutes();
      schedule.durationUnit = 'minutes';
    } else {
      schedule.duration = 24;
      schedule.durationUnit = 'months';
    }

    return schedule;
  }

  // Recurrent event
  Object.assign(schedule, rruleParser(rrule));

  if (dtstart) {
    schedule.start = moment(dtstart).startOf('day');
  }
  if (dtend) {
    schedule.end = moment(dtend).endOf('day').set({ s: 0 });
  }
  if (duration) {
    schedule.duration = moment.duration(duration).asHours();
    schedule.durationUnit = 'hours';
  }

  return schedule;
}
